<div class="modal-overlay"></div>
<div class="wrapper" [class.wrapper-inverse-colors]="inverseColors">
    <button *ngIf="showBackButton" class="icon icon-arrow-back" (click)="backClicked.emit()"></button>
    <h2 i18n class="title-white">{{ title }}</h2>
    <h2 i18n>{{ message }}</h2>
    <div [ngClass]="animationClass"></div>
    @if (
        supervisorState?.subPhase === SupervisorSubPhase.ConfirmGameSelection ||
        supervisorState?.subPhase === SupervisorSubPhase.ConfirmAction
    ) {
        <div class="button-container">
            <button i18n class="button button-medium button-accent" (click)="confirmSupervisorAction.emit()">Confirm</button>
        </div>
    }
</div>
